/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：193
 */

module.exports = {
  historyDialog: "historyDialog_historyDialog__1Wnw7",
  historyPreview: "historyDialog_historyPreview__1G_0g",
  previewDialog: "historyDialog_previewDialog__SWNLq",
  previewHeader: "historyDialog_previewHeader__3_imI",
  projectName: "historyDialog_projectName__3hhau",
  projectTime: "historyDialog_projectTime__2qu7r",
  close: "historyDialog_close__2UFf3",
  icon: "historyDialog_icon__ljgyB",
  previewIframe: "historyDialog_previewIframe__1pHrm",
  historyBar: "historyDialog_historyBar__V-DSy",
  header: "historyDialog_header__1_hXC",
  content: "historyDialog_content__1peW-",
  item: "historyDialog_item__o91qT",
  date: "historyDialog_date__kmQ7Q",
  fold: "historyDialog_fold__15LgW",
  text: "historyDialog_text__2BkXN",
  data: "historyDialog_data__14HNs",
  dot_area: "historyDialog_dot_area__2kjLI",
  dot: "historyDialog_dot__1BkFm",
  line_area: "historyDialog_line_area__2ap_R",
  line: "historyDialog_line__3UchN",
  selected: "historyDialog_selected__1I2Do",
  details: "historyDialog_details__14rBV",
  time: "historyDialog_time__36f5d",
  type: "historyDialog_type__CDUbH",
  avatar: "historyDialog_avatar__260XO",
  save_text: "historyDialog_save_text__1UJOA",
  name: "historyDialog_name__h1Bsi",
  save_type: "historyDialog_save_type__1ugbn",
  button_area: "historyDialog_button_area__2dyNS",
  button: "historyDialog_button__MHvr0",
  hint: "historyDialog_hint__8LPEQ",
  empty: "historyDialog_empty__2jsfR",
  fixedBar: "historyDialog_fixedBar__1dQIc"
}
